<template>
    <div class="page">
        <div class="content"  :style="{backgroundImage: `url(${bgUrl})`}"  @click="closeScreen()">
            <div class="topHead">
                <topComponent title="就业情况数据"></topComponent>
            </div>
            <div class="bottom-row">
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="bottom-col ">
                            <div style="width: 100%;height: 477px" class="boxbgimage" >
                                <div class="itemTitleView">就业意向统计</div>
                                <div class="jiuye jiuye1" ref="JiuYeYiXiangView"></div>
								 <div class="itemTitleView">就业类别统计</div>
								<div class="jiuye" ref="JiuYeLeiBieView"></div>
                            </div>
                            <div style="width: 100%;min-height: 447px;" class="boxbgimage col-3-box-h boxbgimage_l mg_t20">
                                <img  src="../assets/image/line.png" class="line_animation"/>
                                <el-row :gutter="0" class="col-3-box-h">
                                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                        <div style="width: 100%;">
                                            <div class="itemTitleView">签约单位性质分布</div>
                                            <div ref="XingZhiView" class="col-3-item"></div>
                                        </div>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                                        <div style="width: 100%;">
                                            <div class="itemTitleView">签约单位行业分布</div>
											<!-- <div class="animation_1">
												<img src="../assets/image/stu_rings1.png" />
											</div> -->
                                            <div ref="HangYeView" class="col-3-item"></div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" style="position: relative" class="mapMobileHeight">
						<div class="screen-box">
							<div class="screen-item1 screen-bg" @click.stop="clickScreen($event,1)">
								<p><span>{{state.yearText}}</span><img src="../assets/image/screen_icon.png" width="19" height="19" :class="{'screen-on':state.screenOn == 1}"></p>
								<ul class="screen-list" v-show="state.screenOn ==1">
									<li v-for="(item,index) of state.yearList"  :key="index" @click="clickYear(item)">{{item}}</li>
								</ul>
							</div>
							<div class="screen-item2 screen-bg" @click.stop="clickScreen($event,2)">
								<p><span>{{state.facultyidText}}</span><img src="../assets/image/screen_icon.png" width="19" height="19"  :class="{'screen-on':state.screenOn == 2}"></p>
								<ul class="screen-list" v-show="state.screenOn ==2">
									<li  @click="clickFaculty('全部院系','','')">全部院系</li>
									<li v-for="(item,index) of state.facultyidList"  :key="index" @click="clickFaculty(item.name,item.facultyid,item.major_list)">{{item.name}}</li>
								</ul>
							</div>
							<div class="screen-item3 screen-bg" @click.stop="clickScreen($event,3)">
								<p><span>{{state.majorText}}</span><img src="../assets/image/screen_icon.png" width="19" height="19" :class="{'screen-on':state.screenOn == 3}"></p>
								<ul class="screen-list" v-show="state.screenOn ==3">
									<li @click="clickMajor('','全部专业')">全部专业</li>
									<li v-for="(item,index) of state.majorList"  :key="index" @click="clickMajor(item.source_code,item.name)">{{item.name}}</li>
								</ul>
							</div>
						</div>
						<div style="position: relative;">
							<div class="map" style="width: 90%;height: 500px;" ref="mapEcharts" :class="isHenan?'activenone':''"></div>
							<div class="map" style="width: 90%;height: 500px;" ref="henanmapEcharts"  :class="!isHenan?'activenone':''"></div>
						</div>

						<!--小屏适配-->
						<div class="sml" @click="showBox">查看意向地域<img src="../assets/image/alert.png"></div>
						<div class="maplegendBox">
						    <div class="itemTitleView">就业地域（{{!isHenan?'全国':'河南'}}）</div>
						    <ul v-show="!isHenan">
						        <li class="flex_l" v-for="(province,index) of state.proviceLevelList" :key="index">
						            <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
						            <div class="maplegendTitle">{{province.text}}</div>
						            <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.value+'px'}">
						                <span>{{province.count}}</span>
						            </div>
						        </li>
						    </ul>
						    <ul v-show="isHenan">
						        <li class="flex_l" v-for="(province,index) of state.cityLevelList" :key="index">
						            <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
						            <div class="maplegendTitle">{{province.text}}</div>
						            <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.value+'px'}">
						                <span>{{province.count}}</span>
						            </div>
						        </li>
						    </ul>

						</div>
						<div style="width: 100%;height: 270px" class="boxbgimage" >
						    <div class="itemTitleView">就业率排行</div>
						    <div class="jiuye" ref="JiuYeLvView"></div>
						</div>


                    </el-col>
                    <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                        <div class="bottom-col">
							<div style="width: 100%;height: 336px" class="boxbgimage">
							    <div class="col-3-row-1-box">
							        <div class="itemTitleView">毕业去向分析</div>
							        <div class="col-3-row-1-box-chart" ref="BiYeQvXiangView"></div>
							    </div>
							</div>
							<div class="boxbgimage col-3-row-2 mg_t20" style="overflow: unset;min-height: 272px;">
							    <div class="col-3-row-2-box">
							        <div class="itemTitleView">已签约人群学历分布</div>
							        <div class="col-3-row-2-box-item" ref="XueLiView"></div>
							    </div>
							    <div class="col-3-row-2-box">
							        <div class="itemTitleView">性别就业率</div>
							        <div class="col-3-row-2-box-item" ref="XingBieView"></div>
							    </div>
							</div>
                            <div style="width: 100%;height: 290px;" class="boxbgimage mg_t20">

                                <div class="col-3-row-1-box">
                                    <div class="itemTitleView">三种签约方式进度统计</div>
                                    <div class="col-3-row-1-box-chart" ref="JinDuView"></div>
                                </div>
                            </div>

                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

		<!--小屏弹出层-->
		<div class="alertBox" :class="dialogVisible?'active':''" @click="closBox">
		        <div class="map-rank">
		             <div class="title">
		                <div class="tag"></div>
		                <div class="text">就业地域（{{!isHenan?'全国':'河南'}}）</div>
		             </div>
		             <div  class="zhu-chart">
		                <ul v-show="!isHenan">
		                    <li class="flex_l" v-for="(province,index) of state.proviceLevelList" :key="index">
		                        <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
		                        <div class="maplegendTitle">{{province.text}}</div>
		                        <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.value+20+'px'}">
		                            <span>{{province.count}}</span>
		                        </div>
		                    </li>
		                </ul>
		                <ul v-show="isHenan">
		                    <li class="flex_l" v-for="(province,index) of state.cityLevelList" :key="index">
		                        <div :class="{'maplegendNumber':index<=2,'maplegendNumberDown':index>2}">{{index+1}}</div>
		                        <div class="maplegendTitle">{{province.text}}</div>
		                        <div class="maplegendBarhover" :class="{'maplegendBar':index<=2,'maplegendBarDown':index>2}" :style="{width: province.value+40+'px'}">
		                            <span>{{province.count}}</span>
		                        </div>
		                    </li>
		                </ul>
		             </div>
		        </div>
		</div>
    </div>
</template>
<script>
    import {ref,getCurrentInstance,onMounted,reactive} from 'vue'
	import basicApi from '../public/http/index';
    import {
		initJiuYeYiXiang,
		initJiuYeLeiBie,
        initXingZhi,
        initHangYe,
        initJiuYeLv,
		initBiYeQvXiang,
        initXueLi,
		initXingBie,
		initJinDu,
        initmapEcharts,
		inithenanmapEcharts
    } from '../public/workChart'
	import coordMap from "@/public/geoCoordMap";
    export default {
        setup() {
            // const bgUrl = "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fattachments.gfan.com%2Fforum%2F201606%2F21%2F232223fthl5rrbtrz81htt.jpg&refer=http%3A%2F%2Fattachments.gfan.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1614320261&t=721cc876e8fab6e67bb56ac4e7841171";
            // 系统默认图片
            // const bgUrl = "url(\"../assets/image/border_default_bg_l.png\")";
			//就业意向
			const JiuYeYiXiangView=ref('JiuYeYiXiangView')
            // 就业类别
            const JiuYeLeiBieView=ref('JiuYeLeiBieView');
            // 单位性质
            const XingZhiView = ref('XingZhiView');
			//单位行业
            const HangYeView=ref('HangYeView');
			//就业率排行
            const JiuYeLvView=ref('JiuYeLvView');
			//毕业去向
			const BiYeQvXiangView=ref('BiYeQvXiangView')
			//学历就业率
            const XueLiView=ref('XueLiView');
			//性别就业率
			const XingBieView=ref('XingBieView');
			//签约方式进度统计
			const JinDuView=ref('JinDuView');

			var bgUrl = "url(\"../assets/image/border_default_bg_l.png\")";
			let backgroundJson =   localStorage.getItem('background');
			if(backgroundJson){
			    let background = JSON.parse(backgroundJson)
			    if(background.cooperation){
					bgUrl = background.cooperation;
				}
			}

            // 地图
			const dialogVisible = ref(false);
			const mapEcharts = ref(null);
			const henanmapEcharts = ref(null);
			var initEchart1Fn = null;
			var initEchart2Fn = null;
			let timer = ref(false) //定时器
			const changeTime = 6000;
			const state = reactive({
			    proviceLevelList:[],
				cityLevelList:[],
				yearList:[],
				year:2022,
				yearText:'2022',
				facultyidList:[],
				facultyid:'',
				facultyidText:'全部院系',
				majorList:[],
				major:'',
				majorText:'全部专业',
				screenOn:[],

			})
			const series = null;
			var mapSeries = null;
			var henanList = []
			var chinaList = []
			var chinaMap = '';
			var hennanMap = '';
			var  JiuYeYiXiang = null
			var  JiuYeLeiBie = null
			var  XingZhi = null
			var  HangYe = null
			var  JiuYeLv = null
			var  BiYeQvXiang = null
			var  XueLi = null
			var  XingBie = null
			var JinDu = null
			var collegeid = JSON.parse(localStorage.getItem('collegeId'))
			var maptimer = null
			var JYLtimer = null
			

			// 地图动画开始

			var mapSeries = null;
			let isHenan = ref (false);
			let mainDataObj = ref ({});
			let mapList = ref([])
			let henanmapList = ref([])
			//河南地图
			let gethenanmapChart = (mapList) =>{
			    var total = 0;
			    let allData = [];
			    mapList.map((item) => {
			       if (item.name != '其他') {
			          allData.push([{
			            name: '开封市'
			           }, {
			            name: item.name,
			            value: item.count
			           }])
			            total += item.count
			       }
			    });
			    sethenanChartMap(allData,total);
			}

			let sethenanChartMap = (fromData, total)=>{
			    var geoCoordMap = coordMap.henanCityData;
			    var BJData = fromData;
			  var convertData = function(data) {
			    var res = [];
			    for (var i = 0; i < data.length; i++) {
			        var dataItem = data[i];
			        var fromCoord = geoCoordMap[dataItem[0].name];
			        var toCoord = geoCoordMap[dataItem[1].name];
			        if (fromCoord && toCoord) {
			            res.push([{
			                coord: fromCoord
			            }, {
			                coord: toCoord
			            }]);
			        }
			    }
			    return res;
			};
			var color = ['#febd23', '#ffa022', '#a6c84c'];
			var series = [];

			console.log('BJData',BJData);
			[
			['开封市', BJData]
			].forEach(function(item, i) {
			    series.push({
			        name: item[0] + ' Top10',
			        type: 'lines',
			        zlevel: 1,
			        effect: {
			            show: true,
			            period: 6,
			            trailLength: 0.7,
			            color: '#fff',
			            symbolSize: 3
			        },
			        lineStyle: {
			            normal: {
			                color: color[i],
			                width: 0,
			                curveness: 0.2
			            }
			        },
			        data: convertData(item[1])
			    }, {
			        name: item[0] + ' Top10',
			        type: 'lines',
			        zlevel: 2,
			        effect: {
			            show: true,
			            period: 6,
			            trailLength: 0,
			            symbol: 'circle',
			            symbolSize: 4
			        },
			        lineStyle: {
			            normal: {
			                color: color[i],
			                width: 1,
			                opacity: 0.4,
			                curveness: 0.2
			            }
			        },
			        data: convertData(item[1])
			    }, {
			        name: item[0] + ' Top10',
			        type: 'effectScatter',
			        coordinateSystem: 'geo',
			        zlevel: 2,
			        rippleEffect: {
			            brushType: 'stroke'
			        },
			        label: {
			            normal: {
			                show: true,
			                position: 'right',
			                color:'#FFF',
			                formatter: '{b}'
			            }
			        },
			        symbolSize: function(val) {
			            return val[2] / total * 20;
			        },
			        itemStyle: {
			            normal: {
			                color: color[i]
			            }
			        },
			        data: item[1].map(function(dataItem) {
			            return {
			                name: dataItem[1].name,
			                value: geoCoordMap[dataItem[1].name] ? geoCoordMap[dataItem[1].name].concat([dataItem[1].value]) : []
			            };
			        })
			     });
			    });
			    mapSeries = series
			    initEchart2Fn = inithenanmapEcharts(henanmapEcharts.value,series);
			}

			let getmapChart = (mapList) => {
			    var total = 0;
			    let allData = [];
			    mapList.map((item) => {
			       if (item.name != '其他') {
			          allData.push([{
			            name: '郑州市'
			           }, {
			            name: item.name,
			            value: item.count
			           }])
			            total += item.count
			       }
			    });
			    setChartMap(allData,total);
			}

			const setChartMap = (fromData, total) => {
			  var geoCoordMap = coordMap.dataList;
			  var BJData = fromData;
			  var convertData = function(data) {
			    var res = [];
			    for (var i = 0; i < data.length; i++) {
			        var dataItem = data[i];
			        var fromCoord = geoCoordMap[dataItem[0].name];
			        var toCoord = geoCoordMap[dataItem[1].name];
			        if (fromCoord && toCoord) {
			            res.push([{
			                coord: fromCoord
			            }, {
			                coord: toCoord
			            }]);
			        }
			    }
			    return res;
			};
			var color = ['#febd23', '#ffa022', '#a6c84c'];
			var series = [];

			console.log('BJData',BJData);
			[
			['郑州', BJData]
			].forEach(function(item, i) {
			    series.push({
			        name: item[0] + ' Top10',
			        type: 'lines',
			        zlevel: 1,
			        effect: {
			            show: true,
			            period: 6,
			            trailLength: 0.7,
			            color: '#fff',
			            symbolSize: 3
			        },
			        lineStyle: {
			            normal: {
			                color: color[i],
			                width: 0,
			                curveness: 0.2
			            }
			        },
			        data: convertData(item[1])
			    }, {
			        name: item[0] + ' Top10',
			        type: 'lines',
			        zlevel: 2,
			        effect: {
			            show: true,
			            period: 6,
			            trailLength: 0,
			            symbol: 'circle',
			            symbolSize: 4
			        },
			        lineStyle: {
			            normal: {
			                color: color[i],
			                width: 1,
			                opacity: 0.4,
			                curveness: 0.2
			            }
			        },
			        data: convertData(item[1])
			    }, {
			        name: item[0] + ' Top10',
			        type: 'effectScatter',
			        coordinateSystem: 'geo',
			        zlevel: 2,
			        rippleEffect: {
			            brushType: 'stroke'
			        },
			        label: {
			            normal: {
			                show: true,
			                position: 'right',
			                color:'#FFF',
			                formatter: '{b}'
			            }
			        },
			        symbolSize: function(val) {
			            return val[2] / total * 20;
			        },
			        itemStyle: {
			            normal: {
			                color: color[i]
			            }
			        },
			        data: item[1].map(function(dataItem) {
			            return {
			                name: dataItem[1].name,
			                value: geoCoordMap[dataItem[1].name].concat([dataItem[1].value])
			            };
			        })
			     });
			    });

			    mapSeries = series
			    initEchart1Fn = initmapEcharts(mapEcharts.value,series);
			}


			//地图动画结束


            onMounted(() => {
				basicApi.get_year_now().then((res)=>{
					state.yearList = res.data
					clickYear(res.data[res.data.length - 1])
				})

				getFaculty()
				getData()

                window.onresize = function () {
                    // console.log('document.body.clientWidth',document.body.offsetWidth)
					if(JiuYeYiXiang){JiuYeYiXiang.resize();}
                    if(JiuYeLeiBie){JiuYeLeiBie.resize();}
                    if(XingZhi){XingZhi.resize();}
                    if(HangYe){HangYe.resize();}
                    if(JiuYeLv){JiuYeLv.resize();}
					if(BiYeQvXiang){BiYeQvXiang.resize();}
					if(JinDu){JinDu.resize();}
					if(XueLi){XueLi.resize();}
                    if(XingBie){XingBie.resize();}
					if(initEchart1Fn){initEchart1Fn.resize();}
					if(initEchart2Fn){initEchart2Fn.resize();}
					if(mapSeries){
					    initEchart1Fn = initmapEcharts(mapEcharts.value,series);
					    initEchart2Fn = inithenanmapEcharts(henanmapEcharts.value,series);
					}


                }

				
            });
			const closeScreen = ()=>{
				state.screenOn = 0
			}
			const clickYear = (text)=>{
				state.yearText = text
				state.year = text
				getData()
				getFaculty()
			}
			const clickFaculty = (name,id,list)=>{
				state.facultyidText = name
				state.facultyid = id
				state.major = ''
				state.majorText = '全部专业'
				state.majorList = list
				getData()
			}
			const clickMajor = (code,name)=>{
				state.major = code
				state.majorText = name
				getData()
			}
			const clickScreen = (e,index)=>{
				const _this = e.target
				if(index==3&&state.facultyid==''){
					return
				}
				if(state.screenOn != index){
					state.screenOn = index
				}else{
					state.screenOn = 0
				}
			}
			const JYLAnimation = (list)=>{
				let num = 0
				let max = list.length
				JiuYeLv = initJiuYeLv(JiuYeLvView.value, list.slice(num,num+10))
				
				clearInterval(JYLtimer)
				JYLtimer = setInterval(() => {
					if(max<=10){
						return;
					}
					num+=10
					JiuYeLv = initJiuYeLv(JiuYeLvView.value, list.slice(num,num+10))
					if(num+10>=max){
						num = -10
					}
				
				},changeTime)
				
			}
			 const getFaculty = ()=>{
				 basicApi.get_faculty_list(collegeid,state.year).then((res)=>{
					 for(let i=0;i<res.data.length;i++){
						 console.log(res.data[i].year)
						 console.log(state.year)
						 if(res.data[i].year == state.year ){
							state.facultyidList = res.data[i].list
						 }
					 }
				 })
			 }
			 const getData = ()=>{
				 basicApi.get_screen_employment(state.year,state.facultyid,state.major).then((res)=>{
				 	// console.log('数据',res.data)
				 	if(res.status){
				 		let data = res.data
				 		// proviceLevelList = data.proviceLevelList
				 		// console.log(proviceLevelList)
						// data.intention_list.push('')
						  JiuYeYiXiang = initJiuYeYiXiang(JiuYeYiXiangView.value, (data.intention_list || []).sort((a, b) => b.count - a.count))
						  JiuYeLeiBie = initJiuYeLeiBie(JiuYeLeiBieView.value, (data.employment_type_list || []).sort((a, b) => b.count - a.count));
						  XingZhi = initXingZhi(XingZhiView.value, (data.signup_employer_type_list || []).sort((a, b) => b.count - a.count));
						  let signupIndustryList = (data.signup_industry_list || []).sort((a, b) => b.count - a.count).slice(0, 10)
				 		HangYe = initHangYe(HangYeView.value,signupIndustryList);
						console.log(88889999)
						  BiYeQvXiang = initBiYeQvXiang(BiYeQvXiangView.value, (data.graduation_list || []).sort((a, b) => a.count - b.count));
						  XueLi = initXueLi(XueLiView.value, (data.employment_ratio_education_list || []).sort((a, b) => b.count - a.count));
						  XingBie = initXingBie(XingBieView.value, (data.employment_ratio_gender_list || []).sort((a, b) => b.count - a.count));
				 		JinDu = initJinDu(JinDuView.value,data.signup_progress_list);
					
				 		if(state.facultyid !='' && state.major!=''){
							JYLAnimation(data.employment_ratio_major_list)
							// JiuYeLv = initJiuYeLv(JiuYeLvView.value,data.employment_ratio_major_list );
						}else if(state.facultyid !=''){
							JYLAnimation(data.employment_ratio_faculty_list)
							// JiuYeLv = initJiuYeLv(JiuYeLvView.value,data.employment_ratio_faculty_list );
						}else{
							JYLAnimation(data.employment_ratio_faculty_list)
							// JiuYeLv = initJiuYeLv(JiuYeLvView.value,data.employment_ratio_faculty_list );
						}
						if(maptimer){
							clearInterval(maptimer)
						}
						maptimer = setInterval(() => {
						    isHenan.value = !isHenan.value
						},changeTime)
						

	
						mapList.value = data.signup_province_list;
						henanmapList.value = data.signup_city_list;

						// mapList.value = [{name: "郑州市", count: 858, radio: "0.82"},
						//             {name: "长沙市", count: 33, radio: "0.03"},
						//             {name: "南昌市", count: 3, radio: "0.00"},
						//             {name: "济南市", count: 66, radio: "0.06"},
						//             {name: "合肥市", count: 6, radio: "0.01"},
						//             {name: "广州市", count: 2, radio: "0.00"},
						//             {name: "成都市", count: 10, radio: "0.01"},
						//             {name: "重庆市", count: 1, radio: "0.00"},
						//             {name: "武汉市", count: 8, radio: "0.01"},
						//             {name: "上海市", count: 1, radio: "0.00"},
						//             {name: "昆明市", count: 1, radio: "0.00"},
						//             {name: "其他", count: 56, radio: "0.05"}]
						// henanmapList.value=[{name: "郑州市", count: 858, radio: "0.82"},
						// {name: "开封市", count: 808, radio: "0.82"},
						// {name: "洛阳市", count: 108, radio: "0.82"},
						// {name: "平顶山市", count: 858, radio: "0.82"}]
						getmapChart(mapList.value);
						gethenanmapChart(henanmapList.value);


				 		//全国意向地域
				 		let ChinaMaxCount = 0;
				 		data.signup_province_list.map((item,index)=>{
				 		    if(index<=10){
				 		        ChinaMaxCount+=item.count
				 		    }
				 		})
				 		let proviceLevelList = []
				 		data.signup_province_list .map((item,index)=>{
				 		    if(index<=10){
				 		        proviceLevelList.push({
				 		            code: item.code, count: item.count, text: item.name, value:(item.count/ChinaMaxCount)*100
				 		        })
				 		    }
				 		})
				 		state.proviceLevelList = proviceLevelList

				 		//河南意向地域
				 		let HeNanMaxCount = 0;
				 		data.signup_city_list.map((item,index)=>{
				 		    if(index<=10){
				 		        HeNanMaxCount+=item.count
				 		    }
				 		})
				 		let cityLevelList = []
				 		data.signup_city_list.map((item,index)=>{
				 		    if(index<=10){
				 		        cityLevelList.push({
				 		            code: item.code, count: item.count, text: item.name, value:(item.count/HeNanMaxCount)*100
				 		        })
				 		    }
				 		})
				 		state.cityLevelList = cityLevelList

				 	}

				 })
			 }
			 const showBox = () => {
			     dialogVisible.value = true
			 }
			 const closBox = () => {
			     dialogVisible.value = false
			 }
            return{
				getData,
				JiuYeYiXiangView,
                JiuYeLeiBieView,
                XingZhiView,
                HangYeView,
                JiuYeLvView,
				BiYeQvXiangView,
                XueLiView,
				XingBieView,
				JinDuView,
				isHenan,
                bgUrl,
				state,
				henanList,
				clickScreen,
				closeScreen,
				clickYear,
				clickFaculty,
				clickMajor,
				//地图
				mapEcharts,
				henanmapEcharts,
				showBox,
				closBox,
				dialogVisible
            }
        }
    }
</script>

<style scoped>
	p{
		margin: 0;
	}
	ul{
		list-style-type: none;
		margin: 0;
		padding: 0;
	}
    .flex_c{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:center;}
    .flex_l{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-start;}
    .flex_r{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:flex-end;}
    .flex_s{display: flex;flex-direction: row;align-items: center;flex-wrap: wrap;justify-content:space-between;}
    .flex_t{display: flex;flex-direction: row;flex-wrap: wrap;justify-content:center;}
    .page {
        width: 100%;height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
    }
    .content {
        height: 100%;
        background: url("../assets/image/page_default_bg.png") no-repeat;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        padding:0 20px;
        box-sizing: content-box;
        overflow-y:auto;
    }
    .top-row {
        width: 100%;
    }
    .bottom-row {
        width: 100%;
        /*margin-top: 25px;*/
        margin-bottom: 25px;
    }
    .top-item {
        height: 200px;
        margin-bottom:25px;
    }
	.mg_t20{
		margin-top: 20px;
	}
    .bottom-col {
        min-height: 675px;
    }
    .topHead {
        width: 100%;
        height: 100px;
        margin-bottom: 15px;
    }
    .boxbgimage {
        background: url("../assets/image/border_default_bg.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 16px;
        box-sizing: border-box;
        overflow: hidden
    }
    .boxbgimage_l {
        background: url("../assets/image/border_default_bg_l.png") no-repeat;
        background-size: 100% 100%;
        padding: 0 16px;
        box-sizing: border-box;
        overflow: hidden
    }
    .numberTitle {
        font-size: 28px;
        color: rgba(1, 238, 222, 1);
        margin-left: 31px;
        font-weight: bold;
        margin-right: 10px;
    }
    .number{
        font-size: 46px;
        color: rgba(242, 197, 103, 1);
        font-weight: bold;
        z-index: 2;
    }
	.screen-box{
		display: flex;
		padding: 0 20px;
		height: 131px;
		color: #01EEDE;
	}
	.screen-bg{
		position: relative;
		height: 44px;
		background: url(../assets/image/screen_bg.png) no-repeat 0/100% 100%;
		cursor: pointer;
	}
	.screen-bg>p{
		padding:0 16px;
		line-height: 44px;
	}
	.screen-bg span{
		display: inline-block;
		width: calc(100% - 30px);
		overflow-x: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.screen-item1,.screen-item2,.screen-item3{
		text-align: left;
	}
	.screen-item1{
		flex: 3;
	}
	.screen-item2{
		flex: 4;
		margin: 0 20px;
	}
	.screen-item3{
		flex: 5;
	}
	.screen-box img{
		margin-top: 12px;
		margin-left: 10px;
		float: right;
	}
	.screen-on{
		transform: rotate(180deg);
	}
	.screen-list{
		position: absolute;
		height:400px ;
		width: 100%;
		padding:0 16px;
		overflow-x: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		overflow-y: scroll;
		background: rgba(0,0,0,0.3);
		z-index: 99;
	}
	.screen-list li{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.animation_1{
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 30px;
	}
	.animation_1 img{
		display: block;
		width: 250px;
		height: 250px;
		margin: 56px auto 0;
		-webkit-animation: rotating 5s linear infinite;
	}

	.sml {
	    display: none;
	    position: absolute;
	    right: 6px;
	    top: 65px;
	    font-size: 14px;
	    color: #01EEDE;
	    font-weight: bold;
	    z-index: 999;
	}
	.sml img{
		width: 14px;
		height: 14px;
		display: inline-block;
	}
	/* 弹出层 */
	.map-rank{
	    width: 250px;
	    height: 332px;
	    position: absolute;
	    right: 6px;
	    bottom: 40px;
	    display: flex;
	    flex-direction: column;
	    align-items: center;
	}
	.alertBox{
	    width: 100%;
	    height: 100%;
	    position: fixed;
	    z-index: 999;
	    background: rgba(0, 0, 0, 0.7);
	    left: 0;
	    top: 0;
	    transition: all 0.8s ease-out 0s;
	    display: none;
	}
	.alertBox.active{
	    display: block;
	}
	.alertBox .map-rank{
	    position: relative;
	    top: 20%;
	    margin: 0 auto;
	}
	.map-rank .title{
	    display: flex;
	    align-items: center;
	    width: 100%;
	    padding-left: 10px;
	}
	.map-rank .title .tag {
	    width: 3px;
	    height: 20px;
	    border-radius: 1px;
	    background: #01EEDE;
	}
	.map-rank .title .text {
	    font-size: 16px;
	    color: #01EEDE;
	    margin-left: 10px;
	    font-weight: bold;
	}
	.zhu-chart {
	    display: flex;
	    flex-direction: column;
	}
	.zhu-chart .item {
	    display: flex;
	    align-items: center;
	    margin-top: 8px;
	    justify-content: space-between;
	}
	.zhu-chart .item .tag {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    width: 20px;
	    height: 20px;
	    background: linear-gradient(90deg,rgba(248,147,145,1) 0%,rgba(239,88,93,1) 100%);
	    border-radius: 2px;
	    font-size: 12px;
	    color: #ffffff;
	    font-weight: bold;
	}
	.zhu-chart .item .text {
	    font-size: 12px;
	    color: #84C7F7;
	    margin-left: 6px;
	    line-height: 20px;
	}

	.zhu-chart .item .width {
	    width: 60px;
	    height: 5px;
	    background: #666666;
	    border-radius: 2px;
	    margin-left: 12px;
	}

	.width-item {
	    background: linear-gradient(90deg,rgba(248,147,145,1) 0%,rgba(239,88,93,1) 100%);
	    height: 5px;
	    border-radius: 2px;
	}

	.zhu-chart .item .tag1 {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    width: 20px;
	    height: 20px;
	    background: linear-gradient(226deg,rgba(36,160,205,1) 0%,rgba(59,59,227,1) 100%);
	    border-radius: 2px;
	    font-size: 12px;
	    color: #ffffff;
	    font-weight: bold;
	}

	.zhu-chart .item .text {
	    font-size: 12px;
	    color: #84C7F7;
	    margin-left: 4px;
	}
	@-webkit-keyframes rotating{

	    0%{-webkit-transform:rotate(0deg);}

	    100%{-webkit-transform:rotate(360deg);}
	}
    @media screen and (max-width: 1440px) {
        .number{
            font-size: 40px;
            color: rgba(242, 197, 103, 1);
            font-weight: bold;
        }
        .numberTitle {
            font-size: 22px;
            color: rgba(1, 238, 222, 1);
            margin-left: 15px;
            font-weight: bold;
            margin-right: 10px;
        }
    }
        /* title 44px */
    .itemTitleView{
        height: 24px;
        line-height: 24px;
        font-size: 20px;
        color: rgba(1, 238, 222, 1);
        border-left: 3px rgba(1, 238, 222, 1) solid;
        font-weight: bold;
        margin-top: 20px;
        text-align: left;
        padding-left: 5px;
    }
	
    .jiuye {
        width: 100%;
        height: 190px;
        margin-top: 10px;
    }
	.jiuye1{
		height: 190px;
	}
    .col-3-box-h {
        /* height: 385px; */
        overflow: hidden;
    }
    .col-3-item{
        width: 100%;
        height: calc(385px - 14px);
        /*overflow: hidden;*/
        box-sizing: content-box;
    }
    .col-3-row-1-box {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden
    }
    .col-3-row-1-box-chart {
        width: 100%;
        height: calc(100% - 44px - 15px);
        margin-top: 15px;
    }
    .col-3-row-2{
        width: 100%;height: 246px;margin-top: 26px;
    }
    .col-3-row-2-box {
		float: left;
        width: 50%;
        height: 100%;
        display: inline-block
    }

    .col-3-row-2-box-item{
        width: 100%;
        height: calc(100% - 44px);
    }
	.map{
		margin-bottom: 20px;
	}
	.map.activenone{
	    overflow: hidden;
	    height: 0 !important;
	}
    .maplegendBox{
        width: 180px;height: 300px;position: absolute;bottom: 400px;right: 0px;
    }
    .maplegendBox ul{
        list-style: none;
        padding-left: 0;
        margin-left: 0;
    }
    .maplegendBox ul li{
        /* height: 15px; */
        margin: 5px;
    }
    .maplegendNumber {
        width: 14px;
        height: 14px;
        font-size: 10px;
        background-color: #02D1FB;
        text-align: center;
        margin-right: 3px;
        border-radius: 3px;
        color: white;
        line-height: 14px;
    }
    .maplegendNumberDown {
        width: 14px;
        height: 14px;
        font-size: 10px;
        background-color: #3653DE;
        text-align: center;
        margin-right: 3px;
        border-radius: 3px;
        color: white;
        line-height: 14px;
    }
    .maplegendTitle {
        color: #84C7F7;
        font-size: 12px;
        width: 40px;
        text-align: left;
        line-height: 14px;
    }
    .maplegendBar{
        width: 100px;
        height: 15px;
        margin-left: 7px;
        border-bottom-right-radius: 7px;
        border-top-right-radius: 7px;
        background: -webkit-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
        background: -o-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
        background: -ms-linear-gradient(right, #00CCFF 0%,#A6EDFF 100%);
        background: linear-gradient(to right, #00CCFF 0%,#A6EDFF 100%);
        cursor: pointer;
    }
    .maplegendBarDown{
        width: 100px;
        height: 15px;
        margin-left: 7px;
        border-bottom-right-radius: 7px;
        border-top-right-radius: 7px;
        background: -webkit-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
        background: -o-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
        background: -ms-linear-gradient(right, #3B3BE3 0%,#24A0CD 100%);
        background: linear-gradient(to right, #3B3BE3 0%,#24A0CD 100%);
    }
    .maplegendBarhover {
        line-height: 15px;
        color: white;
        text-align: left;
    }
    .maplegendBarhover span{
        opacity: 0;
        margin-left: 5px;
        font-size: 12px;
    }
    .maplegendBarhover:hover{
        border: 1px white solid;
        cursor: pointer;
    }
    .maplegendBarhover:hover span{
        opacity: 1;
    }
	@media screen and (max-width: 1441px){
		.maplegendBox{
			display: none;
		}
		.sml {
		    display: block;
		    cursor: pointer;
		}
	}

	@media screen and (max-width: 992px) {
		.mapMobileHeight .boxbgimage{
			margin: 10px 0;
		}
		.mg_t20{
			margin-top: 10px;
		}
		.screen-box{
			margin-top: 10px;
		}
	}
    @media screen and (max-width: 600px) {
        /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
        .content {
            padding: 5px;
        }
        .top-item {
            margin-bottom:5px;
        }
        .bottom-col {
            margin-bottom: 5px;
        }
        .bottom-row{
            margin-top: 0;
        }
        .content {
            height: 100%;
            background: url("../assets/image/page_mobile_default_bg.png") no-repeat;
            background-size: 100% 100%;
        }
        .numberTitle {
            font-size: 20px;
            margin-left: 15px;
        }
        .number{
            font-size: 36px;
        }
        .top-item {
            height: 100px;
            margin-bottom:15px;
        }
        .col-3-box-h{
            height: 760px
        }
        .col-3-item{
            width: 100%;height: calc(385px - 14px)
        }
        .col-3-row-2-box{
            width: 100%;
            height: 246px;
        }
        .col-3-row-2{
            width: 100%;height: 490px;
        }
        .map{
			height: 280px !important;
		}
		.maplegendBox{
			bottom: 285px;
			left: 0;
			margin: auto;
		}
		.screen-box{
			padding: 0;
			height: 44px;
		}
		.screen-item2{
			margin: 0 5px;
		}
    }
    ::-webkit-scrollbar{width:0px}
    .breathebg{
        width: 254px;
        height: 141px;
        background: url("../assets/image/breathebg.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 10px;
        top: 0;
        -webkit-animation:alpha_ 3s infinite linear ;
    }
    @-webkit-keyframes alpha_ {
        0%{
            opacity:0.2;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
        }
        50%{
            opacity:0.8;
            filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
        }
        100%{
            opacity:0.2;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
        }
    }
    @-webkit-keyframes gogogo {
        0%{
            left: 0;
            opacity:0;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
        }
        25%{
            left: 125px;
            opacity:0.7;
            filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
        }
        50%{
            left: 230px;
            opacity:1;
            filter:alpha(opacity=50); /* 针对 IE8 以及更早的版本 */
        }
        100%{
            left: calc(500px - 100px);
            opacity:0;
            filter:alpha(opacity=00); /* 针对 IE8 以及更早的版本 */
            overflow: hidden;
        }
    }
    .line_animation{
        -webkit-animation:gogogo 5s infinite linear ;
        background-size:100px 3px;
        width: 100px;
        position: absolute;
        height: 3px;
        top: 0;
    }
    .question{
        position: fixed;
        right: 15px;
        top: 15px;
        z-index: 3;
    }
    .mapTypeChange{
        position: absolute;
        right: 15px;
        top: 15px;
    }
</style>
